import React from 'react'

const TeamCapacitySubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_700_37906)" />
    <path
      d="M28.5269 50.5001C24.7616 50.5001 21.0543 50.5001 17.289 50.5001C15.4932 50.5001 14.856 49.6891 15.1456 48.0092C16.2463 41.753 21.6335 37.0609 27.8897 36.8292C34.4935 36.5974 40.3442 40.942 41.8503 47.1403C42.4875 49.6891 41.8503 50.5001 39.2436 50.5001C35.652 50.5001 32.1185 50.5001 28.5269 50.5001Z"
      fill="white"
    />
    <path
      d="M28.585 19.5085C32.64 19.5085 35.8839 22.6946 35.8839 26.6916C35.8839 30.5727 32.4662 33.9325 28.5271 33.9325C24.588 33.9325 21.2861 30.5727 21.2861 26.6337C21.2861 22.6366 24.4722 19.5085 28.585 19.5085Z"
      fill="white"
    />
    <g opacity="0.5">
      <path
        d="M41.2712 19.5087C44.3993 19.5087 46.9481 21.3044 48.1067 24.1429C49.2652 27.0972 48.5122 30.2832 46.1951 32.3107C44.1097 34.1644 40.7499 34.6278 38.3169 33.4113C37.448 32.9479 36.8687 32.7162 37.8535 31.6156C40.2864 28.893 40.2864 25.0697 37.9114 22.2892C36.9266 21.1307 37.2742 20.7252 38.3748 20.2038C39.3596 19.6825 40.4023 19.4508 41.2712 19.5087Z"
        fill="white"
      />
      <path
        d="M45.268 50.2104C46.1949 48.9939 45.8473 47.8933 45.5577 46.7347C44.515 43.0853 42.3137 40.3047 39.0118 38.3931C38.5484 38.1035 37.9112 38.0456 37.6216 37.4663C45.0943 34.9175 53.8413 40.3627 54.884 48.0671C55.0578 49.3415 54.6523 50.1525 53.2621 50.1525C50.5974 50.2104 48.0486 50.2104 45.268 50.2104Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_700_37906"
        x1="35"
        y1="11"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E2EBD" />
        <stop offset="1" stopColor="#4A148C" />
      </linearGradient>
    </defs>
  </svg>
)

export default TeamCapacitySubcategory
